import { noop } from 'lodash'
import { FC, useState } from 'react'
import {
  cn,
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from '@wellesley/ui'

import { TRepost } from '../types'

import RepostButton from '../RepostButton'
import RepostAction from '../RepostAction'
import { getUndoRepostProps } from '../helpers'
import QuoteAction, { RepostTooltipWrapper } from '../QuoteAction'

const RepostDropdown: FC<TRepost> = (props) => {
  const {
    feed,
    counter,
    canRepost,
    isHighlighted,
    isFeedAuthor,
    onQuote,
    onRepost,
  } = props
  const { isDisabledRepost, isActiveUndoRepost } = getUndoRepostProps(props)

  const [isOpen, setIsOpen] = useState(false)

  return (
    <DropdownMenu onOpenChange={setIsOpen}>
      <RepostTooltipWrapper canRepost={canRepost}>
        <DropdownMenuTrigger
          disabled={!canRepost}
          data-testid="repost-trigger"
          className={cn(
            'relative rounded-[3px] focus:outline-none',
            props.canRepost && 'hover:bg-gray-100',
          )}
        >
          <RepostButton
            feed={feed}
            counter={counter}
            isDisabled={!props.canRepost}
            isHighlighted={isHighlighted || isOpen}
            customContent={props.customContent}
          />
        </DropdownMenuTrigger>
      </RepostTooltipWrapper>
      <DropdownMenuContent
        align="start"
        data-testid="repost-menu"
        className="flex min-w-[113px] origin-top-left flex-col gap-0.5 p-2"
        isPortal
      >
        <DropdownMenuItem onClick={isDisabledRepost ? noop : onRepost}>
          <RepostAction
            isFeedAuthor={isFeedAuthor}
            isDisabledRepost={isDisabledRepost}
            isActiveUndoRepost={isActiveUndoRepost}
          />
        </DropdownMenuItem>
        <DropdownMenuItem onClick={canRepost ? onQuote : noop}>
          <QuoteAction canRepost={canRepost} />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default RepostDropdown
